import { UseQueryOptions, infiniteQueryOptions } from '@tanstack/react-query';
import { ReviewParams, getShopReviews } from '~/apis/review';

/** 메루카리 상품상세 조회를 위한 쿼리 옵션 */

export const shopReviewsOptions = (uid: number, params: ReviewParams, queryOptions?: Partial<UseQueryOptions>) => {
  const options = infiniteQueryOptions({
    queryKey: ['shopReviewsOptions', { ...params }],
    queryFn: ({ pageParam }) => getShopReviews(uid, { ...params, page: pageParam }),
    initialPageParam: params.page ?? 0,
    getNextPageParam: (lastPage, _, lastPageParam) => {
      const nextPage = lastPageParam + 1;
      const hasNotNextPage = lastPage.data.totalPages === 0 || lastPageParam + 1 === lastPage.data.totalPages;
      if (hasNotNextPage) return;
      return nextPage;
    },
    placeholderData: (data) => data,
    throwOnError: true,
    enabled: queryOptions?.enabled,
    retry: 0,
    refetchOnWindowFocus: false,
  });

  return options;
};
